export default "__VITE_ASSET__DgA2HIbw__"